"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mobx_1 = require("mobx");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('Broadcaster', shared_1.Styles.smokeyHatesChristmas);
/******************************************** HELPERS *********************************************/
var logHeadWrap = "=".repeat(20);
/**
 * Shorten string to given length, trailing it off with ...
 */
function trunc(str, length, ending) {
    if (length === void 0) { length = 100; }
    if (ending === void 0) { ending = "..."; }
    return str.length > length ? str.substring(0, length - ending.length) + ending : str;
}
/**
 * Convert event.val to array of log-friendly outputs, containing either:
 *     1) a single truncated string;
 *     2) whitespace string & object.
 * To log the return value, pass it to a log function (e.g. log.info) w/ the spread operator (...)
 */
function eventValToDisplayVals(str) {
    return typeof str === "string" && str.length > 74
        ? [trunc(str, 74) + "\n||               [full length of val: " + str.length + " chars]"]
        : ["  ", str];
}
/**
 * Extensively log published event object on receipt of broadcasted event
 */
function logBroadcastedEventReceived(eventName, event, ctx) {
    var header = "\n" + logHeadWrap + " EVENT BROADCASTED OUT OF JVLNS : " + eventName + " " + logHeadWrap;
    var footer = "\n" + Array(header.length).join("=");
    // prettier-ignore
    log.info.apply(log, [header,
        "\n|| - event name:", eventName,
        "\n|| - event (jvlnsBroadcaster." + eventName + ") (below): \n||  ", event,
        "\n||       -> timesRun:", event.timesRun,
        "\n||       -> val:"].concat(eventValToDisplayVals(event.val), ["\n|| - pendingRequests (on broadcaster):", ctx.pendingRequests,
        footer]));
}
/********************************************* EXPORT *********************************************/
/**
 * Contains observables that are mutated by broadcast events
 *
 * Components "subscribe" to broadcasted events by observing the observable tied
 * tied to that event type. Current content of a broadcast event holder is the
 * most recent event's data. Each new event replaces the data in the observable
 */
var Broadcaster = /** @class */ (function () {
    function Broadcaster() {
        var _this = this;
        this.pendingRequests = 0;
        /************** EVENTS **************/
        /**
         * Signals start of record sync
         */
        this.ev_SYNC_START_FETCH = { val: "ev_SYNC_START_FETCH empty", timesRun: 0 };
        /**
         * Signals end of record sync
         */
        this.ev_SYNC_COMPLETE = { val: "ev_SYNC_COMPLETE empty", timesRun: 0 };
        /**
         * Signals logout
         */
        this.ev_LOGOUT = { val: "ev_LOGOUT empty", timesRun: 0 };
        /**
         * Signals store initialization complete
         */
        this.ev_STORE_INITIALIZED = { val: "ev_STORE_INITIALIZED empty", timesRun: 0 };
        /**
         * Signals deletion event
         */
        this.ev_DELETE_RECORD = { val: "ev_DELETE_RECORD empty", timesRun: 0 };
        /**
         * Signals client to regenerate its Pages & update its UI
         */
        this.ev_REGENERATE_PAGES = { val: "ev_REGENERATE_PAGES empty", timesRun: 0 };
        /**
         * Signals that record-ids request is starting
         */
        this.ev_RECORD_IDS_START_FETCH = {
            val: "ev_RECORD_IDS_START_FETCH empty",
            timesRun: 0,
        };
        /**
         * Signals that record-ids request has ended
         */
        this.ev_RECORD_IDS_FETCH_COMPLETE = {
            val: "ev_RECORD_IDS_FETCH_COMPLETE empty",
            timesRun: 0,
        };
        /************** ACTIONS **************/
        /**
         * Emit a broadcast (event) with the given eventType (subscribable event - see above)
         * All subscribing functions will run & receive the given data object (valToTransmit)
         *
         * Example: this.jvlnsBroadcaster.emitBroadcast(`ev_REGENERATE_PAGES`, true);
         *
         * @param {string} eventType Subscribable event. See above events in current class
         * @param {any} valToTransmit Val to send w the broadcast. All subscribing functions get it
         *
         */
        this.emitBroadcast = function (eventType, valToTransmit, syncCompleteConglomerateRequests) {
            log.info("Broadcaster#emitBroadcast :: " + eventType + " ran: valToTransmit:", valToTransmit);
            // Mutate pending requests counter
            if (eventType === "ev_SYNC_START_FETCH")
                _this.pendingRequests++;
            if (eventType === "ev_SYNC_COMPLETE") {
                _this.pendingRequests = _this.pendingRequests - (syncCompleteConglomerateRequests || 1);
            }
            if (_this.pendingRequests < 0)
                _this.pendingRequests = 0;
            // Event setter
            mobx_1.runInAction(function () {
                _this[eventType] = {
                    val: valToTransmit,
                    timesRun: ++_this[eventType].timesRun,
                    pendingRequests: _this.pendingRequests,
                };
            });
        };
        /**
         * Subscribe to a broadcast event type & run given callback each time broadcast occurs
         *
         * Example:
         *     this.jvlnsBroadcaster.subscribe(`ev_REGENERATE_PAGES`, jvlnsEvent => {
         *         log.info(`ev_UI_UPDATE subscriber: broadcast event received:`, jvlnsEvent);
         *     });
         */
        this.subscribe = function (eventName, cb, verbose) {
            if (verbose === void 0) { verbose = true; }
            return mobx_1.reaction(function (r) { return _this[eventName]; }, function (event) {
                if (verbose)
                    logBroadcastedEventReceived(eventName, event, _this);
                return cb(event);
            });
        };
    }
    Broadcaster.Instance = null;
    /**
     * Broadcaster singleton factory
     */
    Broadcaster.new = function () {
        if (!Broadcaster.Instance)
            Broadcaster.Instance = new Broadcaster();
        return Broadcaster.Instance;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_SYNC_START_FETCH", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_SYNC_COMPLETE", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_LOGOUT", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_STORE_INITIALIZED", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_DELETE_RECORD", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_REGENERATE_PAGES", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_RECORD_IDS_START_FETCH", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Broadcaster.prototype, "ev_RECORD_IDS_FETCH_COMPLETE", void 0);
    return Broadcaster;
}());
exports.Broadcaster = Broadcaster;
//# sourceMappingURL=broadcaster.js.map